import React, { useEffect, useState } from "react";
import "../Pages/CSS/Traitement.css";
import {
  Card,
  Row,
  Col,
  Table,
  Select,
  Typography,
  Button,
  Input,
  Statistic,
  Tag,
  Flex,
  Tabs,
  Space,
} from "antd";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Bar,
  BarChart,
  ResponsiveContainer,
  Rectangle,
} from "recharts";
import {

  SyncOutlined,
} from "@ant-design/icons";
import SelectPeriod from "./SelectPeriod";
import { DocumentService } from "../Services/DocumentService";
import { FactureService } from "../Services/FactureService";
import { InfoGenService } from "../Services/InfoGenService";
import { ListAdhService } from "../Services/ListAdhService";
import SelectDoc from "./SelectDoc";
import "../Pages/CSS/DataTables.css";
import moment from "moment";
import ExportDropdown from "./ExportDropdown";
import TabPane from "antd/es/tabs/TabPane";
import { Link } from "react-router-dom";
import { use } from "react";


const { Text } = Typography;

//separateur milieu
const formatNumberWithSeparator = (number) => {
  return number.toLocaleString(); // Utilisez cette fonction pour formater les nombres
};

const contentList = {
  tab1: {
    columns: [
      {
        title: "Numéro", dataIndex: "numdoc", key: "numdoc", align: "center",
        sorter: (a, b) => a.numdoc.localeCompare(b.numdoc),
      },
      {
        title: "Date",
        dataIndex: "update_date",
        key: "update_date",
        align: "center",
        sorter: (a, b) => new Date(a.update_date) - new Date(b.update_date),
        render: (text) => {
          moment.locale("fr"); // Assurez-vous que moment est configuré pour le français
          return (
            <div style={{ whiteSpace: "nowrap" }}>
              {moment(text).format("DD/MM/YYYY HH:mm:ss")} {/* Ajout de l'heure */}
            </div>
          );
        },
      },

      {
        title: "Mat. Part.",
        dataIndex: "matripart",
        key: "matripart",
        align: "center",
        sorter: (a, b) => a.matripart.localeCompare(b.matripart),
      },
      {
        title: "Participants", dataIndex: "participant", key: "participant",
        render: text => <div style={{ whiteSpace: 'nowrap', textAlign: 'left' }}>{text}</div>,
        sorter: (a, b) => a.participant.localeCompare(b.participant),
      },
      {
        title: "Sociétés", dataIndex: "societe", key: "societe",
        render: text => <div style={{ whiteSpace: 'nowrap', textAlign: 'left' }}>{text}</div>,
        sorter: (a, b) => a.societe.localeCompare(b.societe),
      },
      {
        title: "Type bénéf",
        dataIndex: "typebenef",
        key: "typebenef",
        align: "center",
        sorter: (a, b) => a.typebenef.localeCompare(b.typebenef),
      },
      {
        title: "Bénéficiaire", dataIndex: "beneficiaire", key: "beneficiaire",
        render: text => <div style={{ whiteSpace: 'nowrap', textAlign: 'left' }}>{text}</div>,
        sorter: (a, b) => a.beneficiaire.localeCompare(b.beneficiaire),
      },
      {
        title: "Fournisseurs", dataIndex: "fournisseur", key: "fournisseur",
        render: text => <div style={{ whiteSpace: 'nowrap', textAlign: 'left' }}>{text}</div>,
        sorter: (a, b) => a.fournisseur.localeCompare(b.fournisseur),
      },
      {
        title: "Établi par", dataIndex: "user_id", key: "user_id",
        sorter: (a, b) => a.user_id.localeCompare(b.user_id),
      },
      {
        title: "État",
        dataIndex: "etat",
        key: "etat",
        align: "center",
        sorter: (a, b) => a.etat.localeCompare(b.etat),
        render: (etat) => (
          <Tag color={etat === "OK" ? "green" : "red"}>
            {etat === "OK" ? "Traité" : "Non traité"}
          </Tag>
        ),
      },
    ],
  },
  tab2: {
    columns: [
      {
        title: "N°", dataIndex: "numenreg", key: "numenreg", align: "center",
        sorter: (a, b) => a.numenreg.localeCompare(b.numenreg),
      },
      {
        title: "N° facture", dataIndex: "numfact", key: "numfact",
        render: text => <div style={{ whiteSpace: 'nowrap', textAlign: 'left' }}>{text}</div>,
        sorter: (a, b) => a.numfact.localeCompare(b.numfact),
      },
      {
        title: "Date.Fact",
        dataIndex: "datefact",
        key: "datefact",
        align: "center",
        sorter: (a, b) => a.datefact.localeCompare(b.datefact),
        render: (text) => {
          moment.locale("fr");
          return (
            <div style={{ whiteSpace: "nowrap" }}>
              {moment(text).format("DD/MM/YYYY")}
            </div>
          );
        },
      },
      {
        title: "Reçu le",
        dataIndex: "daterecep",
        key: "daterecep",
        align: "center",
        sorter: (a, b) => a.daterecep.localeCompare(b.daterecep),
        render: (text) => {
          moment.locale("fr");
          return (
            <div style={{ whiteSpace: "nowrap" }}>
              {moment(text).format("DD/MM/YYYY")}
            </div>
          );
        },
      },
      {
        title: "Echéance",
        dataIndex: "echeance",
        key: "echeance",
        align: "center",
        sorter: (a, b) => a.echeance.localeCompare(b.echeance),
        render: (text) => {
          moment.locale("fr");
          return (
            <div style={{ whiteSpace: "nowrap" }}>
              {moment(text).format("DD/MM/YYYY")}
            </div>
          );
        },
      },
      {
        title: "Saisie le",
        dataIndex: "datesaisie",
        key: "datesaisie",
        sorter: (a, b) => a.datesaisie.localeCompare(b.datesaisie),
        render: (text) => {
          moment.locale("fr");
          return (
            <div style={{ whiteSpace: "nowrap" }}>
              {moment(text).format("DD/MM/YYYY")}
            </div>
          );
        },
      },
      {
        title: "Traité le",
        dataIndex: "date_process",
        key: "date_process",
        sorter: (a, b) => a.date_process.localeCompare(b.date_process),
        render: (text) => {
          moment.locale("fr");
          return (
            <div style={{ whiteSpace: "nowrap" }}>
              {moment(text).format("DD/MM/YYYY")}
            </div>
          );
        },
      },
      {
        title: "Date Compta",
        dataIndex: "datecompta",
        key: "datecompta",
        align: "center",
        sorter: (a, b) => a.datecompta.localeCompare(b.datecompta),
        render: (text) => {
          moment.locale("fr");
          return (
            <div style={{ whiteSpace: "nowrap" }}>
              {moment(text).format("DD/MM/YYYY")}
            </div>
          );
        },
      },
      {
        title: "Payé le",
        dataIndex: "datereglmt",
        key: "datereglmt",
        sorter: (a, b) => a.datereglmt.localeCompare(b.datereglmt),
        align: "",
        render: (text) => {
          moment.locale("fr");
          return (
            <div style={{ whiteSpace: "nowrap" }}>
              {moment(text).format("DD/MM/YYYY")}
            </div>
          );
        },
      },
      {
        title: "DS",
        dataIndex: "delai_saisie",
        key: "delai_saisie",
        align: "center",
        sorter: (a, b) => a.delai_saisie.localeCompare(b.delai_saisie),
      },
      {
        title: "DT", dataIndex: "delai", key: "delai", align: "center",
        sorter: (a, b) => a.delai.localeCompare(b.delai),
      },
      {
        title: "DC",
        dataIndex: "delai_compta",
        key: "delai_compta",
        align: "center",
        sorter: (a, b) => a.delai_compta.localeCompare(b.delai_compta),
      },
      {
        title: "DR",
        dataIndex: "delai_reglmt",
        key: "delai_reglmt",
        align: "center",
        sorter: (a, b) => a.delai_reglmt.localeCompare(b.delai_reglmt),
      },
      {
        title: "Mois Compta",
        dataIndex: "datetrait",
        key: "datetrait",
        align: "center",
        sorter: (a, b) => a.datetrait.localeCompare(b.datetrait),
        render: (text) => {
          moment.locale("fr");
          return (
            <div style={{ whiteSpace: "nowrap" }}>
              {moment(text).format("MM-YYYY")}
            </div>
          );
        },
      },
      {
        title: "Montant",
        dataIndex: "montfact",
        key: "montfact",
        align: "right",
        sorter: (a, b) => a.montfact.localeCompare(b.montfact),
        render: (text) => (
          <span >
            <strong>
              {formatNumberWithSeparator(text)}
            </strong>
          </span>
        ),
      },
      {
        title: "N° Frs",
        dataIndex: "numfourn",
        key: "numfourn",
        align: "center",
        sorter: (a, b) => a.numfourn.localeCompare(b.numfourn),
      },
      {
        title: "Fournisseur", dataIndex: "raisoc", key: "raisoc",
        render: text => <div style={{ whiteSpace: 'nowrap', textAlign: 'left' }}>{text}</div>,
        sorter: (a, b) => a.raisoc.localeCompare(b.raisoc),
      },
      {
        title: "Spécialité", dataIndex: "intitule", key: "intitule",
        sorter: (a, b) => a.intitule.localeCompare(b.intitule),
      },
      {
        title: "Saisie par",
        dataIndex: "created_by",
        key: "created_by",
        align: "center",
        sorter: (a, b) => a.created_by.localeCompare(b.created_by),
      },
      {
        title: "Traité par",
        dataIndex: "process_by",
        key: "process_by",
        align: "center",
        sorter: (a, b) => a.process_by.localeCompare(b.process_by),
      },
      {
        title: "Comptabilisé par",
        dataIndex: "process_by",
        key: "process_by",
        align: "center",
        sorter: (a, b) => a.process_by.localeCompare(b.process_by),
      },
    ],
  },
};

const Dashboard = () => {
  const [activeTabKey1, setActiveTabKey1] = useState("tab1");
  const [selectedPeriode, setSelectedPeriode] = useState(1);
  const [selectedDoc, setSelectedDoc] = useState("AAA");
  const [selectedFac, setSelectedFac] = useState("R");
  const [selectedSociete, setSelectedSociete] = useState("all");
  const [showParticipants, setShowParticipants] = useState(true);
  const [showEpouses, setShowEpouses] = useState(true);
  const [showEnfants, setShowEnfants] = useState(true);
  const [showAutres, setShowAutres] = useState(true);
  const [showSeriA, setShowSerieA] = useState(true);
  const [showSerieB, setShowSerieB] = useState(true);
  const [donneesStat, setDonneesStat] = useState({});
  const [donneesTab1, setDonneesTab1] = useState([]);
  const [donneesTab2, setDonneesTab2] = useState([]);
  const [list, SetList] = useState([]);
  const [loadingTab, setLoadingTab] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [initialTab1Data, setInitialTab1Data] = useState(0);
  const [initialTab2Data, setInitialTab2Data] = useState(0);
  const [reloadTab1Data, setReloadTab1Data] = useState(0);
  const [reloadTab2Data, setReloadTab2Data] = useState(0);
  const [selectedPeriodeTab1, setSelectedPeriodeTab1] = useState(1);
  const [selectedPeriodeTab2, setSelectedPeriodeTab2] = useState(1);
  const [dateRangeTab1, setDateRangeTab1] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [dateRangeTab2, setDateRangeTab2] = useState(null);
  const documentService = new DocumentService();
  const factureService = new FactureService();
  const infoService = new InfoGenService();
  const listAdhService = new ListAdhService();

  const userProfil = localStorage.getItem("profil");
  const userConnect = JSON.parse(localStorage.getItem("user_connect"));

  const userId = localStorage.getItem('login');
  const userRoleName = localStorage.getItem("role_name");
  // useEffect service pour les card
  useEffect(() => {
    infoService.getAllInfoByPeriod().then((data) => {
      setDonneesStat(data);
    });
  }, []);



  useEffect(() => {
    if (activeTabKey1 === "tab1") {
      if (searchValue === "") {
        setDonneesTab1(initialTab1Data);
      } else {
        setDonneesTab1((prevData) =>
          prevData.filter((item) =>
            Object.values(item).some(
              (val) =>
                typeof val === "string" &&
                val.toLowerCase().includes(searchValue)
            )
          )
        );
      }
    } else if (activeTabKey1 === "tab2") {
      if (searchValue === "") {
        setDonneesTab2(initialTab2Data);
      } else {
        setDonneesTab2((prevData) =>
          prevData.filter((item) =>
            Object.values(item).some(
              (val) =>
                typeof val === "string" &&
                val.toLowerCase().includes(searchValue)
            )
          )
        );
      }
    }
  }, [searchValue, activeTabKey1, initialTab1Data, initialTab2Data]);



  useEffect(() => {
    listAdhService
      .getAllListAdhByPeriod(selectedSociete, selectedPeriodeTab1, selectedPeriodeTab1)
      .then((data) => {
        SetList(data);
      });
  }, [selectedSociete, selectedPeriodeTab1, selectedPeriodeTab1]);

  useEffect(() => {
    setLoadingTab(true);
    if (selectedPeriodeTab1 === 9 && dateRangeTab1) {
      const [startDate, endDate] = dateRangeTab1;
      documentService
        .getDocumentByPeriod9(selectedDoc, selectedPeriodeTab1, startDate.format("YYYY-MM-DD"), endDate.format("YYYY-MM-DD"))
        .then((data) => {
          if (userRoleName === "Point Focal") {
            data = data.filter((doc) => doc.user_id === userId);
          }

          setDonneesTab1(data);
          setInitialTab1Data(data);
        })
        .catch((error) => {
          console.error("Une erreur est survenue : ", error);
        })
        .finally(() => setLoadingTab(false));
    } else {
      documentService
        .getAllDocumentByPeriod(selectedDoc, selectedPeriodeTab1)
        .then((data) => {
          if (userRoleName === "Point Focal") {
            data = data.filter((doc) => doc.user_id === userId);
          }

          setDonneesTab1(data);
          setInitialTab1Data(data);
        })
        .catch((error) => {
          console.error("Une erreur est survenue : ", error);
        })
        .finally(() => setLoadingTab(false));
    }
  }, [selectedDoc, selectedPeriodeTab1, dateRangeTab1, reloadTab1Data]);

  useEffect(() => {
    setLoadingTab(true);
    if (selectedPeriodeTab2 === 9 && dateRangeTab2) {
      const [startDate, endDate] = dateRangeTab2;
      factureService
        .getAllFacturetByPeriod9(selectedFac, selectedPeriodeTab2, startDate.format("YYYY-MM-DD"), endDate.format("YYYY-MM-DD"))
        .then((data) => {
          setDonneesTab2(data);
          setInitialTab2Data(data);
        })
        .catch((error) => {
          console.error("Une erreur est survenue : ", error);
        })
        .finally(() => setLoadingTab(false));
    } else {
      factureService
        .getAllFacturetByPeriod(selectedFac, selectedPeriodeTab2)
        .then((data) => {
          setDonneesTab2(data);
          setInitialTab2Data(data);
        })
        .catch((error) => {
          console.error("Une erreur est survenue : ", error);
        })
        .finally(() => setLoadingTab(false));
    }
  }, [selectedFac, selectedPeriodeTab2, dateRangeTab2, reloadTab2Data]);
  ;



  const onChangePeriodTab1 = (value, dateRange) => {
    setSelectedPeriodeTab1(value);
    if (value === 9 && dateRange) {
      setDateRangeTab1(dateRange.map(date => moment(date)));
    } else {
      setDateRangeTab1(null);
    }
    console.log("Tab1 period changed to:", value, dateRange);
  };

  const onChangePeriodTab2 = (value, dateRange) => {
    setSelectedPeriodeTab2(value);
    if (value === 9 && dateRange) {
      setDateRangeTab2(dateRange.map(date => moment(date)));
    } else {
      setDateRangeTab2(null);
    }
    console.log("Tab2 period changed to:", value, dateRange);
  };



  const onchangeDoc = (value) => {
    setSelectedDoc(value);
  };
  const handleFacSelectChange = (value) => {
    setSelectedFac(value); // Met à jour l'état avec la nouvelle valeur sélectionnée
  };

  const onChangeSociete = (value) => {
    if (value === "all") {
      // Si "Toutes les sociétés" est sélectionné, afficher toutes les sociétés
      setDonneesTab1(initialTab1Data); // Réinitialise les données à toutes les sociétés
    } else {
      setDonneesTab1(initialTab1Data);
      setSelectedSociete(value); // Sélectionne la société spécifique
      setDonneesTab1((data) => {
        return data.filter((doc) => doc.codesoc === value);
      });
    }
  };

  const filterOption = (input, option) => {
    return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };

  const onTab1Change = (key) => {
    setActiveTabKey1(key);
  };

  const handleInputChange = (e) => {
    setSearchValue(e.target.value.toLowerCase());
  };

  const boxStyle = {
    width: "100%",
    height: 10,
    borderRadius: 6,

  };

  const participantsToggle = () => {
    setShowParticipants(!showParticipants);
  };

  const epousesToggle = () => {
    setShowEpouses(!showEpouses);
  };

  const enfantsToggle = () => {
    setShowEnfants(!showEnfants);
  };

  const autresToggle = () => {
    setShowAutres(!showAutres);
  };

  const serieAToggle = () => {
    setShowSerieA(!showSeriA);
  };

  const serieBToggle = () => {
    setShowSerieB(!showSerieB);
  };

  // Vérification si donneesTab1 est un tableau
  const isDataTab1Array = Array.isArray(donneesTab1);

  // Vérification si donneesTab2 est un tableau
  const isDataTab2Array = Array.isArray(donneesTab2);

  // Si l'une des variables n'est pas un tableau, affiche moi une erreur dans la console
  // et initialisation des variables avec des tableaux vides si nécessaire
  if (!isDataTab1Array || !isDataTab2Array) {
    //  console.error("donneesTab1 ou donneesTab2 n'est pas un tableau");
    // initialisation  donneesTab1 et donneesTab2 avec des tableaux vides par défaut
    if (!isDataTab1Array) {
      setDonneesTab1([]);
    }
    if (!isDataTab2Array) {
      setDonneesTab2([]);
    }
  }

  // Contenu pour l'onglet 1 du tableau
  const renderTab1Content = () => (
    <Row
      gutter={12}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
        marginTop: "-10px",
      }}
    >
      <Col xs={24} sm={12} md={12} lg={12}>
        <Flex
          style={boxStyle}
          gap="small"
          justify="flex-start"
          alignItems="flex-start"
        >
          <SelectDoc defaultValue={selectedDoc} onChange={onchangeDoc} />
          <SelectPeriod
            defaultValue={selectedPeriodeTab1}
            onChange={onChangePeriodTab1}
            list={list}
            setList={SetList}
          />
          <Select
            bordered={false}
            style={{ width: "100%", borderBottom: "2px solid #030303" }}
            showSearch
            optionFilterProp="children"
            filterOption={filterOption} // Utilisation de la fonction filterOption ici
            onChange={onChangeSociete}
            defaultValue={selectedSociete}
          >
            <Select.Option value="all">Toutes les sociétés</Select.Option>
            {list.map(
              (adherent) =>
                adherent.codeadht && (
                  <Select.Option
                    key={adherent.codeadht}
                    value={adherent.codeadht}
                  >
                    {`${adherent.codeadht} - ${adherent.intitule} `}
                  </Select.Option>
                )
            )}
          </Select>
        </Flex>
      </Col>

      <Col xs={24} sm={12} md={12} lg={12}>
        <Flex
          style={boxStyle}
          display="flex"
          gap="small"
          justify="flex-end"
          alignItems="flex-end"
        >
          <div style={{ marginLeft: "40px" }}>
            <Input
              onChange={handleInputChange}
              placeholder="Rechercher..."
              bordered={false}
              style={{
                width: "100%",
                borderBottom: "2px solid #030303",
                marginRight: "10px",
              }}
            />
          </div>
          <ExportDropdown
            tableData={activeTabKey1 === "tab1" ? donneesTab1 : donneesTab2}
          />

          <Button
            onClick={() => setReloadTab1Data(Math.random())}
            icon={<SyncOutlined />}
            //className="buttonRefresh"
            style={{ marginRight: "16px", marginTop: "5px", cursor: 'pointer', color: "#f1c24a" }}
            title="Actualiser"
          >
          </Button>


        </Flex>
      </Col>
    </Row>
  );

  // Contenu pour l'onglet 2 du tableau
  const renderTab2Content = () => (
    <Row
      gutter={16}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px", // Réduire la marge en bas
        marginTop: "-10px",
      }}
    >
      <Col xs={16} style={{ display: "flex", justifyContent: "space-around" }}>
        <Flex
          style={boxStyle}
          gap="small"
          justify="flex-start"
          alignItems="flex-start"
        >
          <Select
            bordered={false}
            style={{ width: 200, borderBottom: "2px solid #030303" }}
            defaultValue={selectedFac}
            onChange={handleFacSelectChange}
          >
            {" "}
            {/* Appelle la fonction lorsque la valeur change  */}
            <Select.Option value="R">Reçue</Select.Option>
            <Select.Option value="T">Traitée</Select.Option>
            <Select.Option value="C">Comptabilisée</Select.Option>
            <Select.Option value="P">Payée</Select.Option>
          </Select>
          <SelectPeriod
            defaultValue={selectedPeriode}
            onChange={onChangePeriodTab2}
          />
          <div>
            <Input
              onChange={handleInputChange}
              placeholder="Rechercher..."
              bordered={false}
              style={{ width: "100%", borderBottom: "2px solid #030303" }}
            />
          </div>
        </Flex>
      </Col>
      <Col xs={8} style={{ justifyContent: "end", display: "flex" }}>
        <Flex
          style={boxStyle}
          display="flex"
          gap="small"
          justify="flex-end"
          alignItems="flex-end"
        >
          <ExportDropdown
            tableData={activeTabKey1 === "tab1" ? donneesTab1 : donneesTab2}
          />
          <Button
            onClick={() => setReloadTab2Data(Math.random())}
            icon={<SyncOutlined />}
            style={{ marginRight: "16px", marginTop: "5px", cursor: 'pointer', color: '#f1c24a' }}
            title="Actualiser"
          >
          </Button>
        </Flex>
      </Col>
    </Row>
  );

  const data = [
    { month: "Jan", participants: 30, epouses: 20, enfants: 15, autres: 45 },
    { month: "Feb", participants: 35, epouses: 22, enfants: 18, autres: 25 },
    { month: "Mars", participants: 30, epouses: 20, enfants: 15, autres: 18 },
    { month: "Avr", participants: 35, epouses: 22, enfants: 18, autres: 15 },
    { month: "Mai", participants: 30, epouses: 20, enfants: 15, autres: 18 },
    { month: "Juin", participants: 35, epouses: 22, enfants: 18, autres: 25 },
    { month: "Juil", participants: 30, epouses: 20, enfants: 15, autres: 45 },
    { month: "Aout", participants: 35, epouses: 22, enfants: 18, autres: 25 },
    { month: "Sept", participants: 30, epouses: 20, enfants: 15, autres: 15 },
    { month: "Oct", participants: 35, epouses: 22, enfants: 18, autres: 25 },
    { month: "Nov", participants: 30, epouses: 20, enfants: 15, autres: 45 },
    { month: "Dec", participants: 35, epouses: 22, enfants: 18, autres: 18 },
  ];
  const dataBar = [
    { year: "2020", SerieA: 50, SerieB: 40 },
    { year: "2021", SerieA: 60, SerieB: 45 },
    { year: "2022", SerieA: 50, SerieB: 40 },
    { year: "2023", SerieA: 85, SerieB: 45 },
  ];

  const totalDocuments = () => {
    if (activeTabKey1 === "tab1") {
      if (!donneesTab1 || !Array.isArray(donneesTab1)) {
        return null;
      }

      const total = donneesTab1.length;
      const treated = donneesTab1.filter((doc) => doc.etat === "OK").length;
      const untreated = total - treated;

      const textStyle = {
        color: "#0794f3",
      };

      return (
        <div style={{ ...textStyle }}>
          <Text strong>
            {" "}
            Total Documents: {formatNumberWithSeparator(total)} (Traités: {formatNumberWithSeparator(treated)} / Non Traités:{" "}
            {formatNumberWithSeparator(untreated)})
          </Text>
        </div>
      );
    } else if (activeTabKey1 === "tab2") {
      if (!donneesTab2 || !Array.isArray(donneesTab2)) {
        return null;
      }

      const totalLines = donneesTab2.length;
      const totalAmount = donneesTab2.reduce(
        (acc, currentDoc) => acc + currentDoc.montfact,
        0
      );
      const textStyle = {
        color: "#1008f0",
      };
      return (
        <div style={{ ...textStyle }}>
          <Text strong>
            {" "}
            Total: {formatNumberWithSeparator(totalLines)} ({formatNumberWithSeparator(totalAmount)})
          </Text>
        </div>
      );
    }

    return null;
  };

  const nbSociete =
    donneesStat && donneesStat.nb_societe ? donneesStat.nb_societe : 0;
  const nbFourn =
    donneesStat && donneesStat.nb_fourn ? donneesStat.nb_fourn : 0;
  const nbPart = donneesStat && donneesStat.nb_part ? donneesStat.nb_part : 0;
  const nbEpoux =
    donneesStat && donneesStat.nb_epoux ? donneesStat.nb_epoux : 0;
  const nbEpouse =
    donneesStat && donneesStat.nb_epouse ? donneesStat.nb_epouse : 0;
  const nbEnft = donneesStat && donneesStat.nb_enf ? donneesStat.nb_enf : 0;
  const nbAsc = donneesStat && donneesStat.nb_asc ? donneesStat.nb_asc : 0;


  return (
    <div style={{ width: "100%" }}>
      <Row
        gutter={8}
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
          marginTop: "-20px",
        }}
      >
        <Col xs={24} sm={24} md={12} lg={8} xl={3}>
          <Link to="/adherents"
            className={
              (() => {
                const userPrivileges = Array.isArray(userConnect.privileges)
                  ? userConnect.privileges.find(p => p.alias === '/adherents')
                  : null;
                return userPrivileges && userPrivileges.valeur === false
                  ? 'disabled-link'
                  : '';
              })()
            }
          >
            <Card
              size="small"
              title={
                <Space>

                  <img
                    width="30"
                    height="30"
                    src="https://img.icons8.com/dotty/80/company.png"
                    style={{
                      // filter: "invert(100%)", // Pour rendre l'image blanche
                      boxShadow: "0px 0px 5px rgba(255, 255, 255, 0.7)" // Ajouter une ombre légère pour accentuer
                    }}
                    alt="company" />
                  <strong> Adhérents</strong>
                </Space>
              }
              style={{ backgroundColor: "#d4de1d" }}
              className="raised-card"
            >
              {userRoleName !== "Point Focal" && <Statistic
                style={{ justifyContent: "center", display: "flex" }}
                value={formatNumberWithSeparator(nbSociete)}
                formatter={(value) => `${value}`}
              />}
            </Card>
          </Link>
        </Col>

        <Col xs={24} sm={24} md={12} lg={8} xl={3}>
          <Link to="/fournisseurs"
            className={
              (() => {
                const userPrivileges = Array.isArray(userConnect.privileges)
                  ? userConnect.privileges.find(p => p.alias === '/fournisseurs')
                  : null;
                return userPrivileges && userPrivileges.valeur === false
                  ? 'disabled-link'
                  : '';
              })()
            }
          >
            <Card
              size="small"
              title={
                <Space>
                  <img
                    width="32"
                    height="32"
                    src="https://img.icons8.com/windows/32/supplier.png"
                    alt="supplier"
                    style={{
                      // filter: "invert(100%)", // Pour rendre l'image blanche
                      boxShadow: "0px 0px 5px rgba(255, 255, 255, 0.7)" // Ajouter une ombre légère pour accentuer
                    }}
                  />{" "}
                  <strong>Fourn.Soins</strong>
                </Space>
              }
              style={{ backgroundColor: "#ff6666" }}
              className="raised-card"
            >
              {userRoleName !== "Point Focal" && <Statistic
                style={{ justifyContent: "center", display: "flex" }}
                value={formatNumberWithSeparator(nbFourn)}
                formatter={(value) => `${value}`}
              />}
            </Card>
          </Link>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={3}>
          <Link to="/participants"
            className={
              (() => {
                const userPrivileges = Array.isArray(userConnect.privileges)
                  ? userConnect.privileges.find(p => p.alias === '/participants')
                  : null;
                return userPrivileges && userPrivileges.valeur === false
                  ? 'disabled-link'
                  : '';
              })()
            }
          >
            <Card
              size="small"
              title={
                <Space>
                  <img
                    width="25"
                    height="25"
                    src="https://img.icons8.com/ios-filled/50/conference-foreground-selected.png"
                    alt="conference-foreground-selected"
                    style={{
                      // filter: "invert(100%)", // Pour rendre l'image blanche
                      boxShadow: "0px 0px 5px rgba(255, 255, 255, 0.7)" // Ajouter une ombre légère pour accentuer
                    }}
                  />{" "}
                  <strong>Participants</strong>
                </Space>
              }
              style={{ backgroundColor: "#66ccff" }}
              className="raised-card"
            >
              {userRoleName !== "Point Focal" && <Statistic
                style={{ justifyContent: "center", display: "flex" }}
                value={formatNumberWithSeparator(nbPart)}
                formatter={(value) => `${value}`}
              />}
            </Card>
          </Link>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={3}>
          <Link to="/participants" state={{ tab: "famille", item: "d", selectedOption: "d" }}
            className={
              (() => {
                const userPrivileges = Array.isArray(userConnect.privileges)
                  ? userConnect.privileges.find(p => p.alias === '/participants')
                  : null;
                return userPrivileges && userPrivileges.valeur === false
                  ? 'disabled-link'
                  : '';
              })()
            }
          >
            <Card
              size="small"
              title={
                <Space>
                  <img
                    width="30"
                    height="30"
                    src="https://img.icons8.com/ios-filled/50/face.png"
                    alt="face"
                    style={{
                      // filter: "invert(100%)", // Pour rendre l'image blanche
                      boxShadow: "0px 0px 5px rgba(255, 255, 255, 0.7)" // Ajouter une ombre légère pour accentuer
                    }}
                  />
                  <strong>Epoux</strong>
                </Space>
              }
              style={{ backgroundColor: "#14e055" }}
              className="raised-card"
            >
              {userRoleName !== "Point Focal" && <Statistic
                style={{ justifyContent: "center", display: "flex" }}
                value={formatNumberWithSeparator(nbEpoux)}
                formatter={(value) => `${value}`}
              />}

            </Card>
          </Link>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={3}>

          <Link to="/participants" state={{ tab: "famille", item: "b", selectedOption: "b" }}
            className={
              (() => {
                const userPrivileges = Array.isArray(userConnect.privileges)
                  ? userConnect.privileges.find(p => p.alias === '/participants')
                  : null;
                return userPrivileges && userPrivileges.valeur === false
                  ? 'disabled-link'
                  : '';
              })()
            }
          >
            <Card
              size="small"
              title={
                <Space>
                  <img
                    width="25"
                    height="25"
                    src="https://img.icons8.com/pastel-glyph/64/female-teacher--v2.png"
                    alt="female-teacher--v2"
                    style={{
                      // filter: "invert(100%)", // Pour rendre l'image blanche
                      boxShadow: "0px 0px 5px rgba(255, 255, 255, 0.7)" // Ajouter une ombre légère pour accentuer
                    }}
                  />{" "}
                  Epouses
                </Space>
              }
              style={{ backgroundColor: "#ff99cc" }}
              className="raised-card"
            >
              {userRoleName !== "Point Focal" && <Statistic
                style={{ justifyContent: "center", display: "flex" }}
                value={formatNumberWithSeparator(nbEpouse)}
                formatter={(value) => `${value}`}
              />}
            </Card>
          </Link>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={3}>
          <Link to="/participants" state={{ tab: "famille", item: "c", selectedOption: "c" }}
            className={
              (() => {
                const userPrivileges = Array.isArray(userConnect.privileges)
                  ? userConnect.privileges.find(p => p.alias === '/participants')
                  : null;
                return userPrivileges && userPrivileges.valeur === false
                  ? 'disabled-link'
                  : '';
              })()
            }
          >
            <Card
              size="small"
              title={
                <Space>
                  <img
                    width="30"
                    height="30"
                    src="https://img.icons8.com/ios/50/child-safe-zone--v1.png"
                    alt="child-safe-zone--v1"
                    style={{
                      // filter: "invert(100%)", // Pour rendre l'image blanche
                      boxShadow: "0px 0px 5px rgba(255, 255, 255, 0.7)" // Ajouter une ombre légère pour accentuer
                    }}
                  />{" "}
                  <strong>Enfants</strong>
                </Space>
              }
              style={{ backgroundColor: "#cc99ff" }}
              className="raised-card"
            >
              {userRoleName !== "Point Focal" && <Statistic
                style={{ justifyContent: "center", display: "flex" }}
                value={formatNumberWithSeparator(nbEnft)}
                formatter={(value) => `${value}`}
              />}
            </Card>
          </Link>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={3}>
          <Link to="/participants" state={{ tab: "famille", item: "e", selectedOption: "e" }}
            className={
              (() => {
                const userPrivileges = Array.isArray(userConnect.privileges)
                  ? userConnect.privileges.find(p => p.alias === '/participants')
                  : null;
                return userPrivileges && userPrivileges.valeur === false
                  ? 'disabled-link'
                  : '';
              })()
            }
          >
            <Card
              size="small"
              title={
                <Space>
                  <img
                    width="30"
                    height="30"
                    src="https://img.icons8.com/external-vitaliy-gorbachev-lineal-vitaly-gorbachev/60/external-family-chinese-new-year-vitaliy-gorbachev-lineal-vitaly-gorbachev.png"
                    alt="external-family-chinese-new-year-vitaliy-gorbachev-lineal-vitaly-gorbachev"
                    style={{
                      // filter: "invert(100%)", // Pour rendre l'image blanche
                      boxShadow: "0px 0px 5px rgba(255, 255, 255, 0.7)" // Ajouter une ombre légère pour accentuer
                    }}
                  />{" "}
                  <strong>Ascendants</strong>
                </Space>
              }
              style={{ backgroundColor: "#f0022e" }}
              className="raised-card"
            >
              {userRoleName !== "Point Focal" && <Statistic
                style={{ justifyContent: "center", display: "flex" }}
                value={formatNumberWithSeparator(nbAsc)}
                formatter={(value) => `${value}`}
              />}
            </Card>
          </Link>
        </Col>

        <Col xs={24} sm={24} md={12} lg={8} xl={3}>

          <Card
            size="small"
            title={
              <Space>

                <img width="30" height="30" src="https://img.icons8.com/ios/50/defend-family--v2.png"
                  style={{
                    // filter: "invert(100%)", // Pour rendre l'image blanche
                    boxShadow: "0px 0px 5px rgba(255, 255, 255, 0.7)" // Ajouter une ombre légère pour accentuer
                  }}
                  alt="defend-family--v2" />
                <strong>Total Bénéficiaire</strong>
              </Space>
            }
            style={{ backgroundColor: "#64f5e6" }}
            className="raised-card"
          >
            {userRoleName !== "Point Focal" && <Statistic
              style={{ justifyContent: "center", display: "flex" }}
              value={formatNumberWithSeparator(nbPart + nbEpoux + nbEpouse + nbEnft + nbAsc)}
              formatter={(value) => `${value}`}
            />}
          </Card>

        </Col>
      </Row>
      <Card style={{ marginBottom: "12px" }}>
        <Tabs
          activeKey={activeTabKey1}
          onChange={onTab1Change}
          style={{ marginBottom: "-16px" }}
        >
          <TabPane tab="Documents Etablis" key="tab1">
            {renderTab1Content}
          </TabPane>
          {userProfil !== "role_5" && (
            <TabPane tab="Factures de Soins Reçues" key="tab2">
              {renderTab2Content}
            </TabPane>
          )}
        </Tabs>

        <Table
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          className="custom-header2-table my-custom-table"
          showSorterTooltip={false}
          title={() => (
            <>
              {activeTabKey1 === "tab1" && renderTab1Content()}
              {activeTabKey1 === "tab2" && renderTab2Content()}
            </>
          )}
          pagination={{
            pageSizeOptions: ["5", "10", "20", "50", "100"],
            showSizeChanger: true,
            pageSize: pageSize,
            onShowSizeChange: (current, size) => setPageSize(size),
            position: ["bottomLeft"],
            showTotal: (total, range) => {
              if (activeTabKey1 === "tab1") {
                const treated = (donneesTab1 || []).filter((doc) => doc.etat === "OK").length;
                const untreated = total - treated;
                return (
                  <div style={{ textAlign: "left", fontWeight: 500 }}>
                    Total Documents: {formatNumberWithSeparator(total)} (Traités: {formatNumberWithSeparator(treated)} / Non Traités: {formatNumberWithSeparator(untreated)})
                  </div>
                );
              } else {
                const totalAmount = (donneesTab2 || []).reduce((acc, currentDoc) => acc + (currentDoc.montfact || 0), 0);
                return (
                  <div style={{ textAlign: "left", fontWeight: 500 }}>
                    Total: {formatNumberWithSeparator(total)} ({formatNumberWithSeparator(totalAmount)})
                  </div>
                );
              }
            },
          }}
          bordered
          dataSource={activeTabKey1 === "tab1" ? donneesTab1 : donneesTab2}
          columns={
            activeTabKey1 === "tab1"
              ? contentList.tab1.columns
              : contentList.tab2.columns
          }

          loading={loadingTab}
          scroll={{ x: true }}

          onChange={(pagination, filters, sorter) => { }}
          rowKey={(record) =>
            activeTabKey1 === "tab1" ? record.numdoc : record.numenreg
          }
        />
      </Card>
      <Row gutter={16}>
        <Col span={12}>
          <Card
            title="Consommation par type de bénéficiaire"
            extra={
              <p style={{ color: "lightgrey", textDecoration: "none" }}>docs</p>
            }
          >
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <Button
                onClick={participantsToggle}
                style={{
                  marginRight: "10px",
                  color: showParticipants ? "#8884d8" : "grey",
                  textDecoration: "none",
                }}
              >
                {showParticipants ? "Participants" : <s>Participants</s>}
              </Button>
              <Button
                onClick={epousesToggle}
                style={{
                  marginRight: "10px",
                  color: showEpouses ? "#82ca9d" : "grey",
                  textDecoration: "none",
                }}
              >
                {showEpouses ? "Epouses" : <s>Epouses</s>}
              </Button>
              <Button
                onClick={enfantsToggle}
                style={{
                  marginRight: "10px",
                  color: showEnfants ? "#ffc658" : "grey",
                  textDecoration: "none",
                }}
              >
                {showEnfants ? "Enfants" : <s>Enfants</s>}
              </Button>
              <Button
                onClick={autresToggle}
                style={{
                  color: showAutres ? "#a8323e" : "grey",
                  textDecoration: "none",
                }}
              >
                {showAutres ? "Autres" : <s>Autres</s>}
              </Button>
            </div>
            <ResponsiveContainer width="100%" height={300}>
              <LineChart
                width={650}
                height={300}
                data={data}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Legend />
                {showParticipants && (
                  <Line
                    type="monotone"
                    dataKey="participants"
                    stroke="#8884d8"
                    strokeWidth={2}
                  />
                )}
                {showEpouses && (
                  <Line
                    type="monotone"
                    dataKey="epouses"
                    stroke="#82ca9d"
                    strokeWidth={2}
                  />
                )}
                {showEnfants && (
                  <Line
                    type="monotone"
                    dataKey="enfants"
                    stroke="#ffc658"
                    strokeWidth={2}
                  />
                )}
                {showAutres && (
                  <Line
                    type="monotone"
                    dataKey="autres"
                    stroke="#a8323e"
                    strokeWidth={2}
                  />
                )}
              </LineChart>
            </ResponsiveContainer>
          </Card>
        </Col>
        <Col span={12}>
          <Card
            title="Consommation par type de prestation"
            extra={
              <p style={{ color: "lightgrey", textDecoration: "none" }}>docs</p>
            }
          >
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <Button
                onClick={serieAToggle}
                style={{
                  marginRight: "10px",
                  color: showParticipants ? "#ff99cc" : "grey",
                  textDecoration: "none",
                }}
              >
                {showSeriA ? "SerieA" : <s>SerieA</s>}
              </Button>
              <Button
                onClick={serieBToggle}
                style={{
                  marginRight: "10px",
                  color: showEpouses ? "#66ccff" : "grey",
                  textDecoration: "none",
                }}
              >
                {showSerieB ? "SerieB" : <s>SerieB</s>}
              </Button>
            </div>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart width={650} height={300} data={dataBar}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="year" />
                <YAxis />
                <Tooltip />
                <Legend />
                {showSeriA && (
                  <Bar
                    dataKey="SerieA"
                    fill="#ff99cc"
                    activeBar={<Rectangle fill="pink" stroke="blue" />}
                  />
                )}
                {showSerieB && (
                  <Bar
                    dataKey="SerieB"
                    fill="#66ccff"
                    activeBar={<Rectangle fill="gold" stroke="blue" />}
                  />
                )}
              </BarChart>
            </ResponsiveContainer>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
